<div
  [ngStyle]="getMyStyles()"
  class="loader"
></div>
